import {
  ALLOW_WS_OVERRIDE,
  AUTH_WS_QS_KEY,
  AUTH_WS_SS_KEY,
  AUTH_WS_URL,
} from '@skynet/config-provider';

import { createWsConnect } from '@skynet/data-ws-core';

import { prefix } from './actions';

/**
 * Resolves the Auth WebSocket URL from query-string, sessionStorage, or the
 * default env value, then dispatches a `connect` action for the Auth channel.
 *
 * @example
 * store.dispatch(wsAuthConnect());
 */
export const wsAuthConnect = createWsConnect(prefix, {
  defaultUrl: AUTH_WS_URL,
  ssKey: AUTH_WS_SS_KEY,
  qsKey: AUTH_WS_QS_KEY,
  allowOverride: ALLOW_WS_OVERRIDE,
});
